import React, { Component } from 'react'
/*Redux */
import 'firebase/firestore'
import 'firebase/auth'
import { connect } from 'react-redux'
import propTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Confirm, Popup } from 'semantic-ui-react'

/*Actions */
import {
    setStateGameParent,
    emptyError,
    fetchAllGameParent,
    getGameParentData
} from '../../Actions/GameParentAction'

class SetStateGameParent extends Component {
    state = { open: false }
    open = () => this.setState({ open: true })
    close = () => this.setState({ open: false })

    setStateGameParent(id, status) {
        this.props.setStateGameParent(id, status)
    }

    handleSubmit = (e) => {

        const { id, status } = this.props;

        if (status === "SUSPENDED") {
            this.setStateGameParent(id, "DEFAULT");

        } else {
            this.setStateGameParent(id, "SUSPENDED");
        }
        this.close();
    }


    render() {
        const { success, error, status, id, sentFrom } = this.props;

        let contentPreview = null;

        if (success === false) {
            alert("Error: " + error);
            this.props.emptyError();
        }
        else if (success === true) {
            alert("Game Parent status updated successfully");
            this.props.emptyError();

            // if the requesst come from All gameParent then
            // fetch all GamesParent to update 
            // the new data
            if (sentFrom === "AllGameParents") {
                this.props.fetchAllGameParent();
            }

            // if the requesst come from ViewGameParent then
            // get Game parent data to update 
            // the suspended Game
            if (sentFrom === "ViewGameParent") {
                this.props.getGameParentData(id);
            }
        }
        if (status === "SUSPENDED") {
            contentPreview = (
                <Popup trigger={
                    <button className="seriesCardButtons" onClick={this.open}>
                        <i >
                            <FontAwesomeIcon icon="play" />
                        </i>
                    </button>
                }
                    content='Tap to Active'
                    position='top center'
                />

            )
        }
        else {
            contentPreview = (
                <Popup trigger={
                    <button className="seriesCardButtons"
                        onClick={this.open}>||</button>}
                    content='Tap to Suspend'
                    position='top center'
                />

            )
        }


        return (
            <span >
                {contentPreview}
                <Confirm id="modal" open={this.state.open} onCancel={this.close} onConfirm={this.handleSubmit} />
            </span>)
    }
}

SetStateGameParent.propTypes = {
    setStateGameParent: propTypes.func.isRequired,
    fetchAllGameParent: propTypes.func.isRequired,
    getGameParentData: propTypes.func.isRequired,
}
const mapStateToProps = state =>
({
    success: state.gameParent.setting_state_game_parent_sucessfully,
    error: state.gameParent.setting_state_game_parent_error
})

export default connect
    (mapStateToProps,
        {
            setStateGameParent,
            emptyError,
            fetchAllGameParent,
            getGameParentData
        })
    (SetStateGameParent)
